import WebsiteModel        from '@models/website/WebsiteModel';
import LanguageModel       from '@models/website/LanguageModel';
import doc                 from '@widesk-core/decorators/doc';
import WebsiteServiceModel from '@/models/WebsiteServiceModel';
import Blamable            from '@/models/traits/Blamable';
import { Timestampable }   from '@widesk-core/decorators/timestampable';

@doc.path('/website_languages/{?id}')
@doc.timestampable
abstract class AbstractWebsiteLanguageModel extends Blamable(
	WebsiteServiceModel,
) {
	declare protected _tsFilters: {
		'partial': string;
		'createdAt[before]': string | Date;
		'createdAt[strictly_before]': string | Date;
		'createdAt[after]': string | Date;
		'createdAt[strictly_after]': string | Date;
		'updatedAt[before]': string | Date;
		'updatedAt[strictly_before]': string | Date;
		'updatedAt[after]': string | Date;
		'updatedAt[strictly_after]': string | Date;
		'language': id;
		'website': id;
	};

	declare private _tsSorts: {
		id: string;
		createdAt: string;
		updatedAt: string;
	};

	@doc.boolean declare mandatory: boolean;
	@doc.model(WebsiteModel) declare website: WebsiteModel;
	@doc.model(LanguageModel) declare language: LanguageModel;
}

interface AbstractWebsiteLanguageModel extends Timestampable {}

export default AbstractWebsiteLanguageModel;
